// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_oq-5";
export var filledCircle = "_oq-4";
export var historyEntry = "_oq-3";
export var messageSideLeft = "_oq-1";
export var messageSideRight = "_oq-2";
export var orderTrackingCarouselWrapper = "_oq-6";
export var orderTrackingInfoContainer = "_oq-0";